/* istanbul ignore file */
import React from 'react';
import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from 'framework/utils';
import { useShowContext } from 'framework/show';
import TimelineRecordAuthorWithAccessCheck from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/TimelineRecordAuthorWithAccessCheck';
import { Box } from '@mui/material';
import { personTimelineActionNameSx, personTimelineDateSx, personTimelineHeaderSx } from './personTimelineRecordSx';

interface PersonTimelineRecordHeaderProps {
  createdAtSource?: string;
  createdBySource?: string;
  actionName?: string | ((entity: any) => string);
  timelineId?: string;
  entity?: any;
}

/**
 * Generic timeline record header for person records
 */
const PersonTimelineRecordHeader: React.FC<PersonTimelineRecordHeaderProps> = ({
  actionName,
  createdAtSource = null,
  createdBySource = null,
}) => {
  const { data: entity } = useShowContext();
  const createdAt = entity.getValueBySource(createdAtSource ?? 'createdAt');
  const createdById = entity.getValueBySource(createdBySource ?? 'createdById');
  const createdByName = entity.getValueBySource('createdByName');

  const resultActionName = typeof actionName === 'function' ? actionName(entity.getData()) : actionName;

  return (
    <Box sx={personTimelineHeaderSx}>
      <Box sx={personTimelineActionNameSx}>
        <TimelineRecordAuthorWithAccessCheck id={createdById} name={createdByName} />
        {resultActionName}
      </Box>
      <Box sx={personTimelineDateSx}>
        <ShowDate dateUTC={createdAt} format={DATE_FORMAT.FULL} />
      </Box>
    </Box>
  );
};

export default PersonTimelineRecordHeader;
